class ProductCluster extends HTMLElement {
  constructor() {
    super();
    this.lookImage = null;
    this.productCards = [];
  }

  connectedCallback() {
    this.lookImage = this.querySelector("[look-image]");
    this.productCards = this.querySelectorAll("li[product-id]");

    if (this.lookImage && this.productCards.length) {
      this.setupHoverEvents();
    }
  }

  disconnectedCallback() {}

  setupHoverEvents() {
    this.productCards.forEach((card) => {
      card.addEventListener("mouseenter", (e) => this.handleProductHover(e));
      card.addEventListener("mouseleave", () => this.handleProductLeave());

      const button = card.querySelector("a");
      if (button) {
        button.addEventListener("focus", (e) => this.handleButtonFocus(e));
        button.addEventListener("blur", () => this.handleProductLeave());
      }
    });
  }

  handleProductHover(event) {
    const card = event.currentTarget;
    const productId = card.getAttribute("product-id");
    if (!productId || !this.lookImage) return;

    const mainImage = this.lookImage.querySelector(".main");
    const targetImage = this.lookImage.querySelector(
      `.product-id-${productId}`,
    );
    if (targetImage) {
      targetImage.classList.remove("opacity-0");
      if (mainImage) {
        mainImage.classList.add("opacity-0");
      }
    }
  }

  handleButtonFocus(event) {
    const card = event.target.closest("li[product-id]");
    if (card) {
      this.handleProductHover({ currentTarget: card });
    }
  }

  handleProductLeave(event) {
    if (!this.lookImage) return;

    const mainImage = this.lookImage.querySelector(".main");
    const card = event?.currentTarget;
    if (card) {
      const productId = card.getAttribute("product-id");
      if (!productId) return;

      const targetImage = this.lookImage.querySelector(
        `.product-id-${productId}`,
      );
      if (targetImage) {
        targetImage.classList.add("opacity-0");
      }
      if (mainImage) {
        mainImage.classList.remove("opacity-0");
      }
      return;
    }

    this.lookImage
      .querySelectorAll("[class*='product-id-']")
      .forEach((image) => {
        image.classList.add("opacity-0");
      });
    if (mainImage) {
      mainImage.classList.remove("opacity-0");
    }
  }
}

customElements.define("product-cluster", ProductCluster);
